import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/apiClient';

export type Me = {
  id: string;
  email: string;
  name?: string;
};

export function useSession() {
  return useQuery<Me | null>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const res = await api.get<{ data: Me }>('/v1/me');
        return res.data.data;
      } catch (err: unknown) {
        if (typeof err === 'object' && err && 'response' in err) {
          const status = (err as { response?: { status?: number } }).response?.status;
          if (status === 401) return null;
        }
        throw err;
      }
    },
    retry: false,
    staleTime: 30_000,
  });
}
